__turbopack_context__.v({
  "container": "styles-module__MgCuyq__container",
  "feedbackList": "styles-module__MgCuyq__feedbackList",
  "headingRow": "styles-module__MgCuyq__headingRow",
  "placeholderList": "styles-module__MgCuyq__placeholderList",
  "seeMoreButton": "styles-module__MgCuyq__seeMoreButton",
});
